import * as React from 'react'
import { Box } from '@mui/material'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import * as rt from '../../config/routeType'

const ManagementPage = () => {
  const location = useLocation()

  if (location.pathname === `/${rt.MANAGEMENT_TREE}`)
    return <Navigate to={`/${rt.MANAGEMENT_TREE}/${rt.TREE}`} />

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Outlet />
    </Box>
  )
}

export default ManagementPage
